// extracted by mini-css-extract-plugin
module.exports = {"stationReference":"voucher-form_stationReference__3XBlW","numberStationSelected":"voucher-form_numberStationSelected__Q0BpB","removeCohort":"voucher-form_removeCohort__2HrMg"};